import { useQuery } from '@tanstack/react-query';
import type { MarketDataPipelinesDto, MarketHealthDto } from 'shared';

import { apiClient } from '../../lib/api/client';

const PIPELINE_POLL_INTERVAL_MS = 10_000;

export const marketHealthKeys = {
  all: ['market-health'] as const,
  pipelines: ['market-health', 'pipelines'] as const,
};

async function getMarketHealth(): Promise<MarketHealthDto> {
  const { data } = await apiClient.get<MarketHealthDto>('/market-health');
  return data;
}

export function useMarketHealth() {
  return useQuery({
    queryKey: marketHealthKeys.all,
    queryFn: getMarketHealth,
  });
}

async function getMarketDataPipelines(): Promise<MarketDataPipelinesDto> {
  const { data } = await apiClient.get<MarketDataPipelinesDto>('/market-health/pipelines');
  return data;
}

export function useMarketDataPipelines() {
  return useQuery({
    queryKey: marketHealthKeys.pipelines,
    queryFn: getMarketDataPipelines,
    refetchInterval: (query) =>
      query.state.data?.pipelines.some((pipeline) => pipeline.run !== 'IDLE')
        ? PIPELINE_POLL_INTERVAL_MS
        : false,
  });
}
